import { useApolloClient } from "@apollo/client";
import { createContext, useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getShortIdData } from "Utils/Common";

const SignUpContext = createContext();

export const SignUpProvider = ({ children }) => {
  const [isRegistered, setIsRegistered] = useState(false)
  const [loader, setLoader] = useState(false)
  const apolloClient = useApolloClient();
  const params = useParams();
  const [formData_1, setFormData_1] = useState({
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    code: '',
    company_id: '',
    company_name: '',
    industry: '',
    company_size: '',
    role: '',
    domain_name: '',
    hear_about: '',
    module: ['chat', 'file', 'voice'],
    emails: [''],
    team_title: [''],
  });

  const [passwordStrength, setPasswordStrength] = useState('very-weak');


  const [passwordError, setPasswordError] = useState('');


  const evaluatePasswordStrength = (password) => {
    const lengthCriteria = password.length >= 6 && password.length <= 16;
    if (!lengthCriteria) {
      setPasswordError('Password must be between 6 and 16 characters.');
      return 'very-weak';
    }

    const numberCriteria = /[0-9]/.test(password);
    const uppercaseCriteria = /[A-Z]/.test(password);
    const lowercaseCriteria = /[a-z]/.test(password);
    const specialCharacterCriteria = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    let score = 0;
    if (numberCriteria) score++;
    if (uppercaseCriteria) score++;
    if (lowercaseCriteria) score++;
    if (specialCharacterCriteria) score++;

    if (score === 4) {
      setPasswordError('');
      return 'very-good';
    }
    if (score === 3) {
      setPasswordError('Password could be improved by adding uppercase, lowercase, numbers, or special characters.');
      return 'good';
    }
    if (score === 2) {
      setPasswordError('Password is weak. Try adding numbers, uppercase letters, lowercase letters, and special characters.');
      return 'weak';
    }
    setPasswordError('Password is very weak. Try adding uppercase, lowercase, numbers, and special characters.');
    return 'very-weak';
  };

  const validateEmail = (email) => {
    const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return regex.test(email);
  };

  const isValidUUID = (id) => {
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidV4Regex.test(id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getShortIdData(params.short_url);
        console.log("🚀 ~ fetchData ~ result:", result)
        if (result.status) {

          // setParams_data(result.data);
          if (isValidUUID(result.data?.company_id) && validateEmail(result.data?.email)) {
            setFormData_1((prevData) => ({
              ...prevData,
              email: result.data?.email,
              company_id: result.data?.company_id,
            }));
          }
        }
      } catch (err) {
        console.log("🚀 ~ fetchData ~ err.message:", err.message)
      } finally {
        // setLoading(false);
      }
    };

    if (params.short_url) {
      fetchData();
    }
  }, [params]);

  useEffect(() => {
    console.log(formData_1);
  }, [formData_1]);

  const [verifyCode, setVerifyCode] = useState({
    digit_1: '',
    digit_2: '',
    digit_3: '',
    digit_4: '',
    digit_5: '',
    digit_6: ''
  });

  const [userTokenData, setUserTokenData] = useState(null);

  const launchWorkfreeli = async () => {
    if (userTokenData?.token) {
      localStorage.setItem('token', userTokenData?.token);
      localStorage.setItem("isAuthenticated", true);
      await apolloClient.resetStore();
      // setAuthState(true);
      window.location.href = "/connect";
    }
  }

  return (
    <SignUpContext.Provider value={{ loader, setLoader, formData_1, setFormData_1, verifyCode, setVerifyCode, setUserTokenData, launchWorkfreeli, isRegistered, setIsRegistered, passwordStrength, setPasswordStrength, passwordError, evaluatePasswordStrength }}>
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUp = () => {
  return useContext(SignUpContext);
};
